(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["video-story-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vsc-carousel')) {
  class VscCarousel extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('.vsc__data');
      if (!dataEl) return;
      try { this.videos = JSON.parse(dataEl.textContent); } catch (e) { return; }
      this.currentIndex = 0;
      this.muted = true;
      this.popup = null;
      this.list = this.querySelector('.vsc__list');
      this.prevBtn = this.querySelector('.vsc__arrow--prev');
      this.nextBtn = this.querySelector('.vsc__arrow--next');

      this.querySelectorAll('[data-vsc-index]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const idx = parseInt(btn.dataset.vscIndex, 10);
          if (!Number.isNaN(idx)) this.openPopup(idx);
        });
      });
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollList(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollList(1));
      if (this.list) {
        this.list.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        this.updateArrows();
      }
      this.initPreviewObserver();
      this.onKeydown = (e) => {
        if (e.key === 'Escape' && this.popup && this.popup.classList.contains('is-active')) this.closePopup();
      };
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      if (this.previewObserver) this.previewObserver.disconnect();
      this.querySelectorAll('.vsc__preview[data-src]').forEach((video) => video.pause());
      if (this.popup && this.popup.parentNode) this.popup.parentNode.removeChild(this.popup);
      this.popup = null;
    }

    initPreviewObserver() {
      const previews = this.querySelectorAll('.vsc__preview[data-src]');
      if (!previews.length) return;

      if (!('IntersectionObserver' in window)) return;

      this.previewObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            if (!video.src) {
              video.src = video.dataset.src;
              video.load();
            }
            const playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { rootMargin: '150px 0px', threshold: 0.1 });

      previews.forEach((video) => this.previewObserver.observe(video));
    }

    scrollList(dir) {
      if (!this.list) return;
      const item = this.list.querySelector('.vsc__item');
      if (!item) return;
      const styles = window.getComputedStyle(this.list);
      const gap = parseFloat(styles.columnGap) || parseFloat(styles.gap) || 0;
      this.list.scrollBy({ left: (item.offsetWidth + gap) * dir, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.list) return;
      const max = this.list.scrollWidth - this.list.clientWidth;
      if (this.prevBtn) this.prevBtn.toggleAttribute('disabled', this.list.scrollLeft <= 2);
      if (this.nextBtn) this.nextBtn.toggleAttribute('disabled', this.list.scrollLeft >= max - 2);
    }

    ensurePopup() {
      if (this.popup) return;
      const tpl = this.querySelector('.vsc__popup-template');
      if (!tpl) return;
      this.popup = tpl.content.firstElementChild.cloneNode(true);
      // popup lives on body, so it needs the mobile offset variable itself
      this.popup.style.setProperty('--vsc-popup-bottom-mobile', this.style.getPropertyValue('--vsc-popup-bottom-mobile'));
      document.body.appendChild(this.popup);

      this.popupVideo = this.popup.querySelector('.vsc__popup-video');
      this.progressBox = this.popup.querySelector('.vsc__popup-progress');
      this.popup.querySelector('.vsc__popup-close').addEventListener('click', () => this.closePopup());
      this.popup.querySelector('.vsc__popup-mute').addEventListener('click', () => this.toggleMute());
      this.popup.querySelector('.vsc__popup-playpause').addEventListener('click', () => this.togglePlayPause());
      this.popup.querySelector('.vsc__popup-nav--prev').addEventListener('click', () => this.prevVideo());
      this.popup.querySelector('.vsc__popup-nav--next').addEventListener('click', () => this.nextVideo(false));
      this.popupVideo.addEventListener('timeupdate', () => this.updateProgress());
      this.popupVideo.addEventListener('ended', () => this.nextVideo(true));
      this.popupVideo.addEventListener('play', () => this.popup.classList.remove('is-paused'));
      this.popupVideo.addEventListener('pause', () => this.popup.classList.add('is-paused'));
      this.popupVideo.addEventListener('playing', () => this.popup.classList.remove('is-loading'));
      this.buildProgress();
    }

    buildProgress() {
      this.progressBox.innerHTML = '';
      this.segments = this.videos.map(() => {
        const seg = document.createElement('span');
        seg.className = 'vsc__popup-progress-segment';
        const fill = document.createElement('span');
        fill.className = 'vsc__popup-progress-fill';
        seg.appendChild(fill);
        this.progressBox.appendChild(seg);
        return { seg, fill };
      });
    }

    openPopup(index) {
      this.ensurePopup();
      if (!this.popup) return;
      this.currentIndex = index;
      this.popup.classList.add('is-active');
      this.loadCurrentVideo();
    }

    closePopup() {
      if (!this.popup) return;
      this.popup.classList.remove('is-active');
      try {
        this.popupVideo.pause();
        this.popupVideo.removeAttribute('src');
        this.popupVideo.innerHTML = '';
        this.popupVideo.load();
      } catch (e) {}
      this.segments.forEach((s) => { s.fill.style.width = '0%'; });
    }

    loadCurrentVideo() {
      const data = this.videos[this.currentIndex];
      if (!data || !data.sources || !data.sources.length) { this.nextVideo(true); return; }
      this.popup.classList.add('is-loading');
      this.segments.forEach((s, i) => {
        s.fill.style.width = i < this.currentIndex ? '100%' : '0%';
      });
      this.popupVideo.innerHTML = '';
      data.sources.forEach((src) => {
        const el = document.createElement('source');
        el.src = src.url;
        el.type = src.mime_type;
        this.popupVideo.appendChild(el);
      });
      this.popupVideo.muted = this.muted;
      this.popup.classList.toggle('is-unmuted', !this.muted);
      this.popupVideo.load();
      const p = this.popupVideo.play();
      if (p && p.catch) {
        p.catch(() => {
          this.popupVideo.muted = true;
          this.muted = true;
          this.popup.classList.remove('is-unmuted');
          this.popupVideo.play().catch(() => {});
        });
      }
    }

    nextVideo(closeAtEnd) {
      if (this.currentIndex + 1 >= this.videos.length) {
        if (closeAtEnd) this.closePopup();
        return;
      }
      this.currentIndex += 1;
      this.loadCurrentVideo();
    }

    prevVideo() {
      if (this.currentIndex <= 0) return;
      this.currentIndex -= 1;
      this.loadCurrentVideo();
    }

    togglePlayPause() {
      if (!this.popupVideo) return;
      if (this.popupVideo.paused) {
        const p = this.popupVideo.play();
        if (p && p.catch) p.catch(() => {});
      } else {
        this.popupVideo.pause();
      }
    }

    toggleMute() {
      this.muted = !this.muted;
      this.popupVideo.muted = this.muted;
      this.popup.classList.toggle('is-unmuted', !this.muted);
    }

    updateProgress() {
      if (!this.popupVideo.duration) return;
      const s = this.segments[this.currentIndex];
      if (!s) return;
      s.fill.style.width = (this.popupVideo.currentTime / this.popupVideo.duration) * 100 + '%';
    }
  }
  customElements.define('vsc-carousel', VscCarousel);
}
  } catch(e) { console.error(e); }
})();

})();
